import script from "./SszBenchmarkList.vue?vue&type=script&setup=true&lang=js"
export * from "./SszBenchmarkList.vue?vue&type=script&setup=true&lang=js"

import "./SszBenchmarkList.vue?vue&type=style&index=0&id=2095cd40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2095cd40"]])

export default __exports__